import React from "react";
import VerifyPage from "../Pages/VerifyPage";
import Home from "../Pages/Home";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../node_modules/bootstrap/dist/js/bootstrap.js";
import RewardsPage from "../Pages/RewardsPage";
import Terms from "../Pages/Terms";
import Privacy from "../Pages/Privacy";
import Login from "../Pages/Login/login";
// import Signup from "../Pages/Signup/signup";
import ProtectedRoutes from "./protectedRoutes";
import { CheckUserLogin } from "../context/Auth/checkUserLogin";
import GoogleSignup from "../Pages/Signup/googleSignup";
import Dashboard from "../Pages/Dashboard/dashboard";
import { CheckUserSignup } from "../context/Auth/checkUserSignup";
import BlogPage from "../Pages/BlogPage/BlogPage";
import LearnAnalytics from "../Pages/BlogPosts/LearnAnalytics";
import VideoManaging from "../Pages/BlogPosts/VideoManaging";
import OnlineTeachings from "../Pages/BlogPosts/OnlineTeachings";
import OnlineLearning from "../Pages/BlogPosts/OnlineLearning";
import DynamicTagsBlog from "../Pages/BlogPosts/TagRelatedBlog/TagRelatedBlog.js";
import TagRelatedPost from "../Pages/BlogPosts/TagRelatedBlog/TagRelatedBlog";
import DynamicBlogs from "../Pages/BlogPosts/DynamicBlogs/DynamicBlogs";
import Science from "../Pages/Science/science";
import VerifyEmail from "../Pages/VerifyPage/verifyEmail";
import ProductPage from "../Pages/ProductPage/ProductPage";
import { useSelector } from "react-redux";
import CalibrationGameScreens from "../Pages/CalibrationGameScreens/CalibrationGameCommon/CalibrationGameScreens.js";
import CalibrationGamesInstructions from "../Pages/CalibrationGameScreens/Instructions/CalibrationGameInstructions.js";
import UFOCoordinates from "../Pages/CalibrationGameScreens/UFOCoordinates/UFOCoordinates.js";


const RequiredAuth = (props) => {
  const location = useLocation();

  const user = JSON.parse(useSelector((state) => state.user.user));
  const token = user?.sessionToken;
  const userDetails = user;

  const { children } = props;
  if (userDetails && token) {
    return children;
  } else {
    pluginStateSetter();
    // return children;

    //uncomment this code and delete above return children
    return <Navigate to="/login" replace state={{ path: location.pathname }} />;
  }
  // return userDetails && token ? (
  //   children
  // ) : (

  //   children //remove this line and uncomment below code
  //   // <Navigate
  //   //   to="/login"
  //   //   replace
  //   //   state={{ path: location.pathname }}
  //   // />
  // )
};
const pluginStateSetter = () => {
  // const queryParams = new URLSearchParams(location.search);
  const queryParams = new URLSearchParams(window.location.search);
  console.log("URL Checking", queryParams);
  console.log("Checking auth Page");
  const videoIdParam = queryParams.get("videoId");
  console.log("Video Id on auth Page", videoIdParam);
  if (videoIdParam) {
    localStorage.setItem("videoId", videoIdParam);
  }
};

const NavigationRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<RewardsPage />} />
        <Route path="/:referralId" element={<Home />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/rewards" element={<RewardsPage />} />
        <Route path="/science" element={<Science />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        <Route
          path="/login"
          element={
            <CheckUserLogin>
              <Login />
            </CheckUserLogin>
          }
        />
        <Route
          path="/signup/:referralId"
          element={
            <Home />
            // <CheckUserLogin>
            //   <Signup />
            // </CheckUserLogin>
          }
        />
        <Route path="social/:token" element={<GoogleSignup />} />
        <Route
          path="user/referral"
          element={
            <CheckUserSignup>
              <Dashboard />
            </CheckUserSignup>
          }
        />

        <Route path="/verify/link/:token" element={<VerifyPage />} />
        <Route path="/verify/email/:token" element={<VerifyEmail />} />

        {/* blog */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/learn_analytics" element={<LearnAnalytics />} />
        <Route path="/blog/video_managing" element={<VideoManaging />} />
        <Route path="/blog/online_teaching" element={<OnlineTeachings />} />
        <Route path="/blog/online_learning" element={<OnlineLearning />} />
        <Route path="/blog/:title" element={<DynamicBlogs />} />
        <Route path="/blog/tag/:tagName" element={<DynamicTagsBlog />} />
        <Route path="/blogs/tag/:tag" element={<TagRelatedPost />} />
        {/* blog */}

        <Route
          path="/dashboard/*"
          element={
            <RequiredAuth>
              <ProtectedRoutes />
            </RequiredAuth>
          }
        ></Route>
        <Route path="/calibration/:stateType" element={<CalibrationGameScreens />} />
        <Route
          path="/calibration/instructions"
          element={<CalibrationGamesInstructions />}
        />
        <Route
          path="/calibration/game"
          element={<UFOCoordinates />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default NavigationRouter;
